export const errorsInCurrentStep = (errorKeys, schemaKeys) => {
  return schemaKeys.some((schemaKey) => errorKeys.includes(schemaKey));
};
